import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Modal, Button, Nav, Navbar, NavDropdown, Offcanvas } from 'react-bootstrap';
import { FaRegUserCircle } from 'react-icons/fa';
import { MdArrowDropDown, MdDashboard, MdExitToApp } from 'react-icons/md';
import { toast } from 'react-toastify';
import { ROUTES } from '../../config/routingUrl';
import { getAndCheckLocalStorage, handleClearLocalStorage } from '../../utils/storage/localvalueFuction';
import { localStorageKeys } from '../../utils/storage/localvalue';
import { logoApplication } from '../../utils/dataApi/dataFormApi';
import "./HeaderWeb.css";
import { FaCircleArrowLeft } from 'react-icons/fa6';

const HeaderWeb = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [modalDisconnect, setModalDisconnect] = useState(false);
    const [showOffCanvas, setShowOffCanvas] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

    const [showElementLoginOrDisconnect, setshowElementLoginOrDisconnect] = useState(false)



    // Vérification de la largeur de l'écran pour détecter le mode mobile
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 992);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleShowModalDisconnect = () => setModalDisconnect(true);
    const handleCloseModalDisconnect = () => setModalDisconnect(false);

    const handleDisconnect = () => {
        handleClearLocalStorage();
        window.localStorage.removeItem(localStorageKeys.userId);
        window.location.href = "/";
        toast.success('Déconnexion réussie !');
    };

    return (

        <header className="container-fluid" style={{
            top: "0%",
            zIndex: 1000,
            position: "fixed",
            width: "100%",
            justifyContent: "center",
            display: "flex",
            flexDirection: "row",
            background: "#F5FDF7",
            
        }} >
            <div className="container"
                style={{

                    // background: "white",
                    padding: "10px 10px 5px 10px",
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    width: "100%",
                    // boxShadow: "0px 0px 2.5px #d0d0d0",
                    borderRadius: "50px"
                }}>
                {/*section des logo */}
                <div className="">
                    <Link to="/" onClick={() => { setshowElementLoginOrDisconnect(false) }} >
                        <div className="card-image-design" style={{ cursor: "pointer" }}>
                            <img src={logoApplication} alt='logo' className="header-logo-image-design rounded" />
                        </div>
                    </Link>
                </div>
                {/*section de lien de page en question */}
                <div className="container-navbar-element-design">
                    {!isMobile && (
                        <Link to={`/${ROUTES.CAR_LIST_WEB}`} onClick={() => { setshowElementLoginOrDisconnect(false) }} className={`${location.pathname === `/${ROUTES.CAR_LIST_WEB}` ? "container-navbar-design-link-active" : "container-navbar-design-link"} text-dark`}>
                            <div>Explorer</div>
                        </Link>
                    )}
                    {!isMobile && (
                        <Link to={`/${ROUTES.ABOUTUS}`} onClick={() => { setshowElementLoginOrDisconnect(false) }} className={`${location.pathname === `/${ROUTES.ABOUTUS}` ? "container-navbar-design-link-active" : "container-navbar-design-link"} text-dark`}>
                            <div>Qui somme nous ?</div>
                        </Link>
                    )}
                    {!isMobile && (
                        <Link to={`/${ROUTES.CONTACT}`} onClick={() => { setshowElementLoginOrDisconnect(false) }} className={`${location.pathname === `/${ROUTES.CONTACT}` ? "container-navbar-design-link-active" : "container-navbar-design-link"} text-dark`}>
                            <div>Contact</div>
                        </Link>
                    )}


                    <div classNAme="container-navbar-design-button-parent ">
                        {!isMobile && (
                            <div className="container-navbar-design-button" onClick={() => { setshowElementLoginOrDisconnect(!showElementLoginOrDisconnect) }}
                                style={{ cursor: "pointer" }}
                            >
                                <div>Compte</div>
                                <div>
                                    <MdArrowDropDown className="text-primary" size={30} />
                                </div>
                            </div>
                        )}

                        {isMobile && (
                            <div className="container-navbar-design-button" style={{ cursor: "pointer" }} onClick={() => setShowOffCanvas(true)}>
                                <div >☰</div>
                            </div>
                        )}

                        <div style={{ display: showElementLoginOrDisconnect ? "block" : "none" }} className="container-navbar-design-button-card shadow bg-white">

                            {
                                getAndCheckLocalStorage(localStorageKeys.userId) &&
                                (
                                    <>
                                        <Link to={`/${ROUTES.DASHBOARD}`} className="text-dark"><div className="py-1" onClick={() => { navigate(`/${ROUTES.DASHBOARD}`) }}><span><MdDashboard className="text-primary" size={20} /> Administration</span></div></Link>
                                        <Link to={`/${ROUTES.DASHBOARD}/${ROUTES.RESERVATIONS_REQUEST_LIST}`} className="text-dark"><div className="py-1" onClick={() => { navigate(`/${ROUTES.DASHBOARD}/${ROUTES.RESERVATIONS_REQUEST_LIST}`) }}><span><FaCircleArrowLeft className="text-primary" size={20} /> Réservations</span></div></Link>

                                    </>
                                )
                            }
                            {
                                !getAndCheckLocalStorage(localStorageKeys.userId) &&
                                (
                                    <>
                                        <Link to={`/${ROUTES.LOGIN}`} className="text-dark"><div className="py-1" onClick={() => { navigate(`/${ROUTES.LOGIN}`) }}><span><FaCircleArrowLeft className="text-primary" size={20} /> Se connecter</span></div></Link>
                                        <Link to={`/${ROUTES.SIGNUP_PRESTATAIRE}`} className="text-dark"><div className="py-1" onClick={() => { navigate(`/${ROUTES.SIGNUP_PRESTATAIRE}`) }}><span className="font-bold" style={{ fontWeight: "600" }}>Créer un compte pour votre agence</span></div></Link>
                                        <Link to={`/${ROUTES.SIGNUP}`} className="text-dark"><div className="py-1" onClick={() => { navigate(`/${ROUTES.SIGNUP}`) }}><span className="font-bold" style={{ fontWeight: "600" }}>Créer un compte client</span></div></Link>
                                    </>
                                )
                            }



                            {
                                getAndCheckLocalStorage(localStorageKeys.userId) && (
                                    <div className="py-1" style={{ cursor: "pointer" }} onClick={handleShowModalDisconnect}><span><FaCircleArrowLeft className="text-primary" size={20} /> Se déconnecter</span></div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>



            {/* canvas */}
            <Offcanvas show={showOffCanvas} onHide={() => setShowOffCanvas(false)} placement="start">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <Link to="/" className="navbar-brand">
                            <img src={logoApplication} style={{ maxHeight: "50px", height: "50px" }} alt="Logo" />
                        </Link>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Nav className="flex-column">
                        <Nav.Link as={Link} to="/" onClick={() => setShowOffCanvas(false)}>Accueil</Nav.Link>
                        <Nav.Link as={Link} to={`/${ROUTES.CAR_LIST_WEB}`} onClick={() => setShowOffCanvas(false)}>Rechercher offre de réservation</Nav.Link>
                        <Nav.Link as={Link} to={`/${ROUTES.ABOUTUS}`} onClick={() => setShowOffCanvas(false)}>En savoir plus</Nav.Link>
                        <Nav.Link as={Link} to={`/${ROUTES.CONTACT}`} onClick={() => setShowOffCanvas(false)}>Contact</Nav.Link>

                        {/* Account Dropdown dans l'OffCanvas */}
                        <NavDropdown title="Compte" id="account-dropdown">
                            {!getAndCheckLocalStorage(localStorageKeys.userId) ? (
                                <>
                                    <NavDropdown.Item as={Link} to={`/${ROUTES.LOGIN}`} onClick={() => setShowOffCanvas(false)}>Connexion</NavDropdown.Item>
                                </>
                            ) : (
                                <>
                                    <NavDropdown.Item as={Link} to={`/${ROUTES.DASHBOARD}`} onClick={() => setShowOffCanvas(false)}>Administration</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to={`/${ROUTES.DASHBOARD}/${ROUTES.RESERVATIONS_REQUEST_LIST}`} onClick={() => setShowOffCanvas(false)}>Réservations</NavDropdown.Item>
                                    <NavDropdown.Item as="button" onClick={handleShowModalDisconnect}>
                                        <MdExitToApp /> Déconnexion
                                    </NavDropdown.Item>
                                </>
                            )}
                        </NavDropdown>
                    </Nav>
                </Offcanvas.Body>
            </Offcanvas>



            {/*disconnect */}
            <Modal show={modalDisconnect} onHide={handleCloseModalDisconnect} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Déconnexion</Modal.Title>
                </Modal.Header>
                <Modal.Body>Voulez-vous vous déconnecter ?</Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={handleCloseModalDisconnect}>Annuler</Button>
                    <Button variant="primary" onClick={() => { handleCloseModalDisconnect(); handleDisconnect(); }}>Se Déconnecter</Button>
                </Modal.Footer>
            </Modal>
        </header>


    );
};

export default HeaderWeb;
